import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { toast } from "sonner";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function Lesson() {
  const { authAxios } = useAuth();
  const { tr, lang } = useLang();
  const { courseId, lessonId } = useParams();
  const nav = useNavigate();
  const [l, setL] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await authAxios.get(`/academy/courses/${courseId}/lessons/${lessonId}?lang=${lang}`);
        setL(r.data);
      } catch (e) {}
    })();
    // eslint-disable-next-line
  }, [courseId, lessonId, lang]);

  const complete = async () => {
    setBusy(true);
    try {
      await authAxios.post(`/academy/courses/${courseId}/lessons/${lessonId}/complete`);
      toast.success(tr("academy_completed"));
      setL((prev) => prev ? { ...prev, completed: true } : prev);
    } catch (e) {} finally { setBusy(false); }
  };

  if (!l) return (
    <div className="min-h-screen flex flex-col"><Header /><main className="flex-1 max-w-4xl mx-auto w-full px-6 py-16 text-[#a9a9b8]">{tr("loading")}</main></div>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-10">
        <Link to={`/academy/${courseId}`} data-testid="lesson-back" className="inline-flex items-center gap-2 text-[#a9a9b8] hover:text-[#e6c687] text-sm">
          <ArrowLeft size={14} /> {l.course_title}
        </Link>
        <div className="mt-6">
          <div className="pfi-overline">{l.module_title} · {l.duration}</div>
          <h1 className="mt-3 font-serif text-3xl sm:text-4xl">{l.title}</h1>
        </div>
        <article className="mt-8 pfi-card p-8 prose prose-invert max-w-none">
          <p className="text-[#c8c8d4] leading-relaxed text-lg">{l.body}</p>
        </article>
        <div className="mt-8 flex items-center gap-3">
          {l.completed ? (
            <div className="inline-flex items-center gap-2 text-[#10B981] text-sm" data-testid="lesson-completed-badge">
              <CheckCircle2 size={16} /> {tr("academy_completed")}
            </div>
          ) : (
            <button data-testid="lesson-complete-btn" onClick={complete} disabled={busy} className="pfi-btn-gold rounded-full px-5 py-2.5 text-sm disabled:opacity-60">
              {busy ? tr("loading") : tr("academy_mark_complete")}
            </button>
          )}
          <button data-testid="lesson-next" onClick={() => nav(`/academy/${courseId}`)} className="pfi-btn-outline rounded-full px-5 py-2.5 text-sm">
            {tr("academy_next")}
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
